module.exports = __webpack_public_path__ + "img/damuge-hei.05798f7d.svg";